import { t, translationExists, defaultLocale } from './i18n.js';

export function setTitle(title) {
  const prefix = title ? `${title} - ` : '';
  document.title = prefix + t('name');
  setPropertyMeta('og:title', document.title);
}

function getMetaTag(name) {
  let meta = document.head.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }

  return meta;
}

function setPropertyMeta(property, content) {
  let tags = Array.from(document.head.querySelectorAll(`meta[property="${property}"]`));
  const meta = tags.shift() || document.createElement('meta');
  meta.setAttribute('property', property);
  meta.setAttribute('content', content);
  if (!meta.isConnected) document.head.appendChild(meta);
  tags.forEach(tag => tag.remove());
}

export function setMeta(name, content) {
  if (typeof name === 'object') {
    Object.keys(name).forEach(key => setMeta(key, name[key]));
    return;
  }

  const defaultValue = t(`meta.${name}`);
  const value = Array.isArray(content)
    ? content.concat(defaultValue).join(', ')
    : content || defaultValue;

  getMetaTag(name).setAttribute('content', value.replace(/[\n\r]+/g, ' '));
  if (name === 'description') setPropertyMeta('og:description', value.replace(/[\n\r]+/g, ' '));
}

export function setRouteMeta({ response }) {
  const html = document.documentElement;

  if (html.lang !== response.params.lang) {
    html.lang = response.params.lang || defaultLocale;
  }

  const prefix = `meta.${response.name}`;

  if (translationExists(prefix)) {
    setTitle(t(`${prefix}.title`));
    setMeta('keywords', t(`${prefix}.keywords`));
    setMeta('description', t(`${prefix}.description`));
  } else {
    setTitle();
    setMeta('keywords');
    setMeta('description');
  }

  updateShareButtons();
}

export function setPageMeta(page) {
  const meta = page.meta || {};

  if (meta.title) {
    document.title = meta.title;
    setPropertyMeta('og:title', document.title);
  } else {
    setTitle(page.title);
  }
  setMeta('keywords', meta.keywords || '');
  setMeta('description', meta.description || '');
  updateShareButtons();
}

export const SHARE_BUTTONS_ID = 'share-buttons';
let shareButtons;
function updateShareButtons() {
  if (!window.__sharethis__) return;
  shareButtons ??= document.getElementById(SHARE_BUTTONS_ID);
  shareButtons.setAttribute('data-url', window.location.href);
  shareButtons.setAttribute('data-title', document.title);
  shareButtons.setAttribute('data-description', getMetaTag('description').getAttribute('content'));
}
